export default __webpack_public_path__ + "static/media/contest.eb8007ce.svg";